import { uniqBy } from "lodash";
import { allCountries } from "../components/PhoneNumber/country_data";

export const countries = uniqBy(allCountries, "iso2");
